module.exports = __webpack_public_path__ + "static/img/incon-newEn.d889f3e2.png";